/**
 * Company: SPHMedia
 * Description: [NDR Banner]
 */

import NDRDesktopIcon from "@assets/ndrImages/ndr2026-banner-logo.svg";
import NDRMobileIcon from "@assets/ndrImages/ndr2026-banner-logo-mobile.svg";
import { NDR_PAGE_URL_ALIAS } from "@config/ndrConstants";
import Link from "@elements/Typography/Link";
import { ReactElement } from "react";

/**
 * GEBanner
 * Description: [NDR Banner component]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function NDRBanner(): ReactElement {
  const landingPagePath = `${NDR_PAGE_URL_ALIAS}?ref=banner`;

  return (
    <div className="flex justify-center items-center bg-gradient-to-r from-blue-950 to-red-450 py-1">
      <div className="gap-2.5 lg:gap-2 h-[52px] lg:h-[37px] items-center hidden md:flex">
        <img
          src={NDRDesktopIcon}
          alt="NDR Banner logo"
          className="w-[41px] h-[44px] lg:w-[35px] lg:h-[37px]"
        />
        <Link
          destination={landingPagePath}
          className="text-xs font-medium lg:text-md lg:font-semibold text-text-inverse font-primary underline leading-[normal]"
        >
          Dapatkan berita terkini Hari Kebangsaan 2026 di sini
        </Link>
      </div>
      <div className="h-[58px] flex md:hidden gap-2 items-center justify-center">
        <img
          src={NDRMobileIcon}
          alt="NDR Banner logo mobile"
          width={47}
          height={50}
        />
        <div className="flex flex-col gap-[2px]">
          <Link
            destination={landingPagePath}
            className="text-[14px] font-medium text-text-inverse font-primary underline leading-[20px]"
          >
            Dapatkan berita terkini Hari
            <br />
            Kebangsaan 2026 di sini
          </Link>
        </div>
      </div>
    </div>
  );
}
